import React from "react"
import { graphql } from "gatsby"
import { HelmetDatoCms } from "gatsby-source-datocms"

import Hero from "../components/organisms/Hero"
import DynamicSections from "../components/organisms/DynamicSections"

export default ({
  data: {
    datoCmsHomePage: {
      heroHeading,
      heroTextNode: {
        childMarkdownRemark: { heroText },
      },
      heroButtonTxt,
      heroButtonLink,
      heroBackground: { heroBackground },
      sections,
      seoMetaTags,
    },
  },
  location,
}) => (
  <>
    <HelmetDatoCms seo={seoMetaTags} />

    <Hero
      heroBackground={heroBackground}
      heroHeading={heroHeading}
      heroText={heroText}
      heroButtonTxt={heroButtonTxt}
      heroButtonLink={heroButtonLink}
    />
    <DynamicSections sections={sections} location={location} />
  </>
)

export const pageQuery = graphql`
  query homePage {
    datoCmsHomePage {
      heroHeading
      heroTextNode {
        childMarkdownRemark {
          heroText: html
        }
      }
      heroButtonTxt
      heroButtonLink
      heroBackground {
        heroBackground: fluid(maxWidth: 1400, maxHeight: 800) {
          ...GatsbyDatoCmsFluid
        }
      }
      sections: dynamicSection {
        ... on DatoCmsContactFormSection {
          internal {
            type
          }
          id
          title
          phone: includePhoneNumber
          dateTime: includeDateTime
        }

        ... on DatoCmsImageGridSection {
          internal {
            type
          }
          id
          imageGallery {
            galleryTitle
            titleAlign
            rowMin
            rowMax
            imageGallery {
              caption
              link
              title
              imageFile {
                fluid(maxWidth: 1088) {
                  ...GatsbyDatoCmsFluid
                }
              }
            }
          }
        }

        ... on DatoCmsIconSection {
          internal {
            type
          }
          id
          iconGroup {
            heading
            textNode {
              childMarkdownRemark {
                html
              }
            }
            icon
            linkText
            linkUrl
          }
        }

        ... on DatoCmsPhotoTextSection {
          internal {
            type
          }
          id
          heading
          textNode {
            childMarkdownRemark {
              html
            }
          }
          imageOn
          linkText
          linkURL: linkUrl
          image {
            fluid(maxWidth: 544, imgixParams: { auto: "compress, format" }) {
              ...GatsbyDatoCmsFluid
            }
          }
        }

        ... on DatoCmsTestimonialsSection {
          internal {
            type
          }
          id
          heading
          testimonialList: testimonial {
            title
            bodyNode {
              childMarkdownRemark {
                html
              }
            }
            cite
          }
        }

        ... on DatoCmsTextSection {
          internal {
            type
          }
          id
          textAlignment
          body: dynamicFreeTextNode {
            childMarkdownRemark {
              html
            }
          }
        }
      }

      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
  }
`
